import wabaChatsTypes from "./wabaChatsTypes";
import wabaChatsApi from "./wabaChatsApi";

const wabaChatsActions = {
    getConversations: (branchId, page, search) => async dispatch => {
        dispatch({ type: wabaChatsTypes.GET_CONVERSATIONS_PENDING });
        try {
            const res = await wabaChatsApi.getConversations(branchId, page, search);
            dispatch({
                type: wabaChatsTypes.GET_CONVERSATIONS_SUCCESS,
                payload: { conversations: res.data.conversations || [], total: res.data.total || 0 }
            });
        } catch (e) {
            dispatch({ type: wabaChatsTypes.GET_CONVERSATIONS_ERROR });
        }
    },
    pollConversations: (branchId, page, search) => async dispatch => {
        try {
            const res = await wabaChatsApi.getConversations(branchId, page, search);
            dispatch({
                type: wabaChatsTypes.GET_CONVERSATIONS_SUCCESS,
                payload: { conversations: res.data.conversations || [], total: res.data.total || 0 }
            });
        } catch (e) { /* silent */ }
    },
    getMessages: (branchId, conversationId) => async dispatch => {
        dispatch({ type: wabaChatsTypes.GET_MESSAGES_PENDING });
        try {
            const res = await wabaChatsApi.getMessages(branchId, conversationId);
            dispatch({ type: wabaChatsTypes.GET_MESSAGES_SUCCESS, payload: res.data || [] });
        } catch (e) {
            dispatch({ type: wabaChatsTypes.GET_MESSAGES_ERROR });
        }
    },
    loadMoreMessages: (branchId, conversationId, beforeTimestamp) => async dispatch => {
        try {
            const res = await wabaChatsApi.getMessages(branchId, conversationId, beforeTimestamp);
            dispatch({ type: wabaChatsTypes.LOAD_MORE_MESSAGES_SUCCESS, payload: res.data || [] });
        } catch (e) { /* silent */ }
    },
    pollNewMessages: (branchId, conversationId, afterTimestamp) => async dispatch => {
        try {
            const res = await wabaChatsApi.getMessages(branchId, conversationId, null, afterTimestamp);
            const newMsgs = res.data || [];
            if (newMsgs.length > 0) {
                dispatch({ type: wabaChatsTypes.POLL_NEW_MESSAGES_SUCCESS, payload: newMsgs });
            }
        } catch (e) { /* silent */ }
    },
    sendTextMessage: (branchId, conversationId, text) => async dispatch => {
        const tempId = 'temp_' + Date.now();
        dispatch({
            type: wabaChatsTypes.SEND_MESSAGE_OPTIMISTIC,
            payload: {
                id: tempId,
                conversation_id: conversationId,
                direction: 'outbound',
                type: 'text',
                content: { body: text },
                status: 'pending',
                timestamp: new Date().toISOString(),
            }
        });
        try {
            const res = await wabaChatsApi.sendTextMessage(branchId, conversationId, text);
            dispatch({
                type: wabaChatsTypes.SEND_MESSAGE_SUCCESS,
                payload: { tempId, message: res.data }
            });
        } catch (e) {
            dispatch({ type: wabaChatsTypes.SEND_MESSAGE_ERROR, payload: tempId });
        }
    },
    sendMediaMessage: (branchId, conversationId, file) => async dispatch => {
        const tempId = 'temp_' + Date.now();
        const isImage = file.type.startsWith('image/');
        const isVideo = file.type.startsWith('video/');
        const mediaType = isImage ? 'image' : isVideo ? 'video' : 'document';
        const localPreviewUrl = URL.createObjectURL(file);
        dispatch({
            type: wabaChatsTypes.SEND_MESSAGE_OPTIMISTIC,
            payload: {
                id: tempId,
                conversation_id: conversationId,
                direction: 'outbound',
                type: mediaType,
                content: { body: file.name, filename: file.name, media_url: localPreviewUrl },
                status: 'pending',
                timestamp: new Date().toISOString(),
            }
        });
        try {
            const uploadRes = await wabaChatsApi.uploadFile(file);
            const fileUrl = uploadRes.data?.url || uploadRes.data?.file_url;
            if (!fileUrl) throw new Error('Upload failed - no URL returned');
            dispatch({
                type: wabaChatsTypes.SEND_MESSAGE_OPTIMISTIC,
                payload: {
                    id: tempId,
                    conversation_id: conversationId,
                    direction: 'outbound',
                    type: mediaType,
                    content: { body: file.name, filename: file.name, media_url: fileUrl },
                    status: 'pending',
                    timestamp: new Date().toISOString(),
                }
            });
            const res = await wabaChatsApi.sendMediaMessage(branchId, conversationId, {
                type: mediaType,
                media_url: fileUrl,
                caption: '',
                filename: file.name,
            });
            dispatch({
                type: wabaChatsTypes.SEND_MESSAGE_SUCCESS,
                payload: { tempId, message: res.data }
            });
        } catch (e) {
            dispatch({ type: wabaChatsTypes.SEND_MESSAGE_ERROR, payload: tempId });
        }
    },
    setActiveConversation: (conversationId) => ({
        type: wabaChatsTypes.SET_ACTIVE_CONVERSATION, payload: conversationId
    }),
    markRead: (branchId, conversationId) => async dispatch => {
        try {
            await wabaChatsApi.markRead(branchId, conversationId);
            dispatch({ type: wabaChatsTypes.MARK_READ_SUCCESS, payload: conversationId });
        } catch (e) { /* silent */ }
    },
    dismissMessage: (branchId, conversationId, messageId) => async dispatch => {
        try {
            await wabaChatsApi.dismissMessage(branchId, conversationId, messageId);
            dispatch({ type: wabaChatsTypes.DISMISS_MESSAGE_SUCCESS, payload: messageId });
        } catch (e) { /* silent */ }
    },
    clearMessages: () => ({ type: wabaChatsTypes.CLEAR_MESSAGES }),
    clearAll: () => ({ type: wabaChatsTypes.CLEAR_ALL }),
}
export default wabaChatsActions
